import { render, staticRenderFns } from "./NMAttributeEditorComponent.vue?vue&type=template&id=77ba14ab&scoped=true"
import script from "./NMAttributeEditorComponent.vue?vue&type=script&lang=js"
export * from "./NMAttributeEditorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ba14ab",
  null
  
)

export default component.exports